import { render, staticRenderFns } from "./IconBeakerOutline.vue?vue&type=template&id=a35e0aa8"
import script from "./IconBeakerOutline.vue?vue&type=script&lang=js"
export * from "./IconBeakerOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports